import { AnyAction } from 'redux';
import produce from 'immer';
import { PROPERTY_PORTFOLIO_ACTIONS } from '../actions/index';
import { AUTH_ACTIONS } from '../actions/auth';

export interface PropertyPortfolioState {
  data?: any;
  isLoading: boolean;
}

const initialState: PropertyPortfolioState = {
  data: undefined,
  isLoading: false,
};

const propertyPortfolioReducer = (
  state = initialState,
  action: AnyAction
): PropertyPortfolioState => {
  switch (action.type) {
    case PROPERTY_PORTFOLIO_ACTIONS.SET_PROPERTY_DATA:
      return produce(state, (draft) => {
        draft.data = action.payload;
      });

    case PROPERTY_PORTFOLIO_ACTIONS.SET_PROPERTY_PORTFOLIO_LOADING:
      return produce(state, (draft) => {
        draft.isLoading = action.payload;
      });

    case AUTH_ACTIONS.LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default propertyPortfolioReducer;
